import React from "react"
import { push } from "connected-react-router"
import { connect } from "react-redux"

class ErrorBoundary extends React.Component {
    state = { hasError: false }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidCatch() {
        const { push } = this.props
        push("/error")
    }

    render() {
        return this.props.children
    }
}

const mapDispatchToProps = {
    push,
}
export default connect(null, mapDispatchToProps)(ErrorBoundary)
